import styleInject from '../../../../external_node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".popup-header.wcl-1r2e8cf{padding:10px 0;box-sizing:border-box;text-align:center;font-size:22px;font-weight:bold;text-transform:uppercase;color:#fff;border-bottom:1px solid rgba(255, 255, 255, 0.3)}";
styleInject(css_248z);

export { css_248z as default };
//# sourceMappingURL=PopupHeader.css.js.map
